import { render, staticRenderFns } from "./calculationDetail.vue?vue&type=template&id=03d1bc92&scoped=true"
import script from "./calculationDetail.vue?vue&type=script&lang=js"
export * from "./calculationDetail.vue?vue&type=script&lang=js"
import style0 from "./calculationDetail.vue?vue&type=style&index=0&id=03d1bc92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d1bc92",
  null
  
)

export default component.exports